import { render, staticRenderFns } from "./drProjectRegister.vue?vue&type=template&id=28e4cc18&scoped=true"
import script from "./drProjectRegister.vue?vue&type=script&lang=js"
export * from "./drProjectRegister.vue?vue&type=script&lang=js"
import style0 from "./drProjectRegister.vue?vue&type=style&index=0&id=28e4cc18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4cc18",
  null
  
)

export default component.exports